import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FrListSelect from '../components/FrListSelect'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { colors } from '../utils/vars'
import { mPERC, mVAL } from '../utils/masks';

const swal = withReactContent(Swal)

function Usuarios(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [comboGrupoUsu, setComboGrupoUsu] = useState([{ value: '', display: '' }])
  const [enableEdit, setEnableEdit] = useState('N')
  const [listUni, setListUni] = useState([])
  const [checkedUni, setCheckedUni] = useState([])
  const [listSed, setListSed] = useState([])
  const [checkedSed, setCheckedSed] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Usuários', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Usuários', 'Inclusao'))
      }

      setListUni(await api.getListData('unidades'))
      setListSed(await api.getListData('sedes'))

      setComboGrupoUsu(await api.getComboData('grupo_usuarios'))

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/usuarios?pk_usu=' + query.codigo).then(r => {
          if (r.data[0]) {
            let auxValues={...r.data[0]}
            auxValues.limite_desconto_precentual = mVAL(auxValues.limite_desconto_precentual)
            setData(auxValues)
            console.log(r.data[0])
            api.get('/usuarios/unidades?pk_usu=' + query.codigo).then(r => {
              setCheckedUni(r.data.pk_uni)
              api.get('/usuarios/sedes?pk_usu=' + query.codigo).then(r => {
                setCheckedSed(r.data.pk_sed)
                swal.close()
              })
            })
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'nome',
      'fk_gpu',
      'email',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr === 'fk_gpu') fieldName = 'GRUPO DE USUÁRIO'
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    console.log(data.limite_desconto_precentual)
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        console.log(auxValues.limite_desconto_precentual)
        auxValues.limite_desconto_precentual = (auxValues.limite_desconto_precentual).replace('.','').replace(',','.')
        auxValues.pk_uni = checkedUni
        auxValues.pk_sed = checkedSed
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/usuarios/edit', auxValues)
              .then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                    html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    html: `<p style='color: ${colors.info900}'></p>`,
                    icon: 'warning',
                  })
                }
              })
              .catch(r => {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Ocorreu um erro ao salvar o registro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              })
          } else {
            try {
              api.post('/usuarios/add', auxValues).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    // auxValues[e.target.name] = e.target.value;
    switch (e.target.name) {
      case 'limite_desconto_precentual': auxValues[e.target.name] = mVAL(e.target.value);
      break;
      default: auxValues[e.target.name] = e.target.value;
    }
    console.log(e.target.value, e.target.name, 'limite_desconto_precentual')
    setData(auxValues);
  };


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Usuário</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='100'
            value={data.nome || ''}
            onChange={handleChange}
            name="nome"
            id="nome"
            color="#083c7c"
            label="Nome"
            variant="outlined"
            size="small"
            required
            style={{ width: 500 }}
          />
          <FrSelect
            value={data.fk_gpu || ''}
            onChange={handleChange}
            name="fk_gpu"
            id="fk_gpu"
            label='Grupo de Usuário'
            data={comboGrupoUsu}
            style={{ width: 250 }}
          />
          <FrDatePicker
            name="ultimo_login"
            id="ultimo_login"
            color="#389492"
            label="Ultimo Login"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            value={(data.ultimo_login || '').split("T")[0]}
            onChange={handleChange}
            disabled
            hidden={!updateType}
          />
          <br />
          <FrTextInput
            value={data.limite_desconto_precentual || ''}
            onChange={handleChange}
            name="limite_desconto_precentual"
            id="limite_desconto_precentual"
            color="#083c7c"
            label="Limite Desconto Percentual (%)"
            variant="outlined"
            size="small"
            endAdornment="%"
            style={{ width: 230 }}
          />
          <FrTextInput
            value={data.limite_desconto_parcelas || ''}
            onChange={handleChange}
            name="limite_desconto_parcelas"
            id="limite_desconto_parcelas"
            color="#083c7c"
            label="Limite Desconto Parcelas"
            variant="outlined"
            size="small"
            required
            style={{ width: 250 }}
          />

          <br />
          
          <p>Informações para Login</p>
          <FrTextInput
            maxLength='200'
            value={data.email || ''}
            onChange={handleChange}
            name="email"
            id="email"
            color="#083c7c"
            label="E-mail"
            variant="outlined"
            size="small"
            required
            style={{ width: 300 }}
            disabled={updateType}
          />
          <FrSelect
            value={data.ativo || ''}
            onChange={handleChange}
            name="ativo"
            id="ativo"
            label='Ativo'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 100 }}
            hidden={!updateType}
          />
          <br />
          {/* <br />

          <div>
            Unidades que este usuário pode acessar:
            <FrListSelect pk="pk_uni" text="descricao" data={listUni} setChecked={setCheckedUni} checked={checkedUni} />
          </div> */}

          <br />

          <div>
            Sedes que este usuário pode acessar:
            <FrListSelect pk="pk_sed" text="descricao" data={listSed} setChecked={setCheckedSed} checked={checkedSed} />
          </div>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Usuarios;
